import React from 'react';
import { Box, Button, Grid } from '@mui/material';
import theme from '../../theme';
import Text from './Text';
import Images from '../../services/data/images';

const styles = {
  footer: {
    background: '#4B429F',
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    marginTop: theme.spacing(5),
  },
};

export default function Footer() {
  return (
    <>
      <Box position="relative" style={styles.footer}>
        <Grid container justifyContent="space-around">
          <Box
            component="img"
            src={Images.envelop}
            sx={{ width: '250px', height: '190px' }}
          />
          <Box mt={5} mr={15}>
            <Text
              sx={{ position: 'relative', zIndex: 10 }}
              color="#FFFFFF"
              size="huge"
            >
              Are you a DIYer?
            </Text>
            <Text
              sx={{ position: 'relative', zIndex: 10 }}
              color="#FFFFFF"
              size="medium"
              mv={2}
            >
              Post your projects on Renomate for FREE and join our DIY
              community!
            </Text>
            <Button
              href="https://portal.renomate.app/"
              variant="contained"
              color="secondary"
              sx={{
                borderRadius: '50px',
                paddingInline: '40px',
                paddingY: '15px',
                position: 'relative',
                zIndex: 20,
              }}
            >
              Post a project
            </Button>
          </Box>
        </Grid>

        <Box
          component="img"
          src={Images.footer_back}
          display={{ xs: 'none', md: 'block' }}
          style={{
            position: 'absolute',
            zIndex: 1,
            bottom: 0,
            right: 0,
            top: 0,
          }}
        />
        <Box
          component="img"
          src={Images.footer_back2}
          display={{ xs: 'none', md: 'block' }}
          style={{
            position: 'absolute',
            zIndex: 2,
            bottom: 0,
            right: 0,
            top: 0,
          }}
        />
      </Box>
    </>
  );
}
